import { render, staticRenderFns } from "./CandidateProfileModal.vue?vue&type=template&id=5d12b1f8&scoped=true"
import script from "./CandidateProfileModal.vue?vue&type=script&lang=js"
export * from "./CandidateProfileModal.vue?vue&type=script&lang=js"
import style0 from "./CandidateProfileModal.vue?vue&type=style&index=0&id=5d12b1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12b1f8",
  null
  
)

export default component.exports